import { useContext } from 'react'
import Context from '../Context'
// Antd
import { Button, Drawer } from 'antd'
import UpdateUserInfo from './Children/UpdateUserInfo'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import useUpdateUser from './useUpdateUser'
// helpers
import get from 'lodash/get'

const children: { [key: string]: React.FC<any> } = {
  updateUser: UpdateUserInfo,
  createUser: UpdateUserInfo
}

const Modal: React.FC = () => {
  const { t } = useTranslation()
  const {
    states: { open, type },
    actions: { onClose, setSelectedUser }
  } = useContext(Context)
  const { onClick, form, isLoading } = useUpdateUser()

  const handleClose = () => {
    onClose()
    setSelectedUser(null)
  }


  const Child = get(children, type, (): React.FC => null)

  const props = {
    open,
    footer: [],
    width: '100vw',
    onClose: handleClose,
    extra:
      type === 'updateUser' ? (
        <Button type="primary" onClick={onClick} loading={isLoading}>
          {t('UPDATE_USER')}
        </Button>
      ) : <Button type="primary" onClick={onClick} loading={isLoading}>
        Crear nuevo usuario
      </Button>,
    children: <Child form={form} />,
    className: styles.modal,
    destroyOnClose: true
  }

  return (
    <>
      <Drawer {...props} />
    </>
  )
}

export default Modal
